import { typedDoc, getDocument } from '@/lib/firebase/firestore'
import { submitTaxProfileFn } from '@/lib/firebase/functions'
import type { MemberTaxProfileDocument, TaxEntityType } from '@/types'

export interface SaveTaxProfileInput {
  legalName: string
  businessName?: string
  address: {
    line1: string
    line2?: string
    city: string
    state: string
    postalCode: string
  }
  entityType: TaxEntityType
  backupWithholding: boolean
  signatureImageUrl: string
  taxIdPlain: string
}

export const taxProfileService = {
  async getMyProfile(
    memberId: string,
  ): Promise<(MemberTaxProfileDocument & { id: string }) | null> {
    const ref = typedDoc<MemberTaxProfileDocument>('memberTaxProfiles', memberId)
    const data = await getDocument(ref)
    return data ? { ...data, id: memberId } : null
  },

  async saveProfile(input: SaveTaxProfileInput): Promise<void> {
    await submitTaxProfileFn(input)
  },
}
